module.exports = __webpack_public_path__ + "img/guide-3.8ae49cc2.png";